import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { ISchedule } from '../../../types/schedule'
import { fetchProductJobSchedule } from './fetchProductJobSchedule'
import { getUrlWithVersion } from '../../../api/api'

export const updateProductJobSchedule = createAsyncThunk<
    void,
    { productId: string; schedule: ISchedule[] },
    ThunkConfig<string>
>('schedulesSlice/updateProductJobSchedule', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { productId, schedule } = args

    try {
        await api.put(
            getUrlWithVersion(
                `/products/${productId}/core_settings/job_schedule`
            ),
            schedule
        )
        dispatch(fetchProductJobSchedule({ productId }))

        throwSuccessMessage('Schedule is successfully updated')
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to update product job schedule')
    }
})
